import { Select } from "antd";
import Globe from "../images/globe-icon.svg";
import { useTranslation } from "react-i18next";
import ArrowDownIcon from "./ArrowDownIcon";

const { Option } = Select;

const containerStyle = {
  display: "flex",
  width: 92,
  alignItems: "center",
  marginRight: 29,
};

const logoStyle = {
  width: 24,
  height: 24,
};

const selectStyle = (color) => ({
  fontSize: 13,
  fontWeight: 400,
  width: "auto",
  minWidth: 90,
  color,
});

const Localization = ({ icon = Globe, textColor = "#3A3F47" }) => {
  const { i18n } = useTranslation();
  const setLangauge = {
    "en-US": "en-US",
    "ja-JP": "ja-JP",
    jpn: "jpn",
    "de-DE": "de-DE",
  };
  return (
    <div className="localization" style={{ ...containerStyle }}>
      <img style={{ ...logoStyle }} src={icon} alt="Language" />
      <Select
        style={{ ...selectStyle(textColor) }}
        dropdownStyle={{ border: 0 }}
        defaultValue={"en-US"}
        value={setLangauge[i18n.language] || "en-US"}
        bordered={false}
        suffixIcon={<ArrowDownIcon />}
        onChange={(e) => {
          i18n.changeLanguage(e);
        }}
      >
        <Option value="en-US">English</Option>
        <Option value="ja-JP">Japanese</Option>
        <Option value="de-DE">German</Option>
      </Select>
    </div>
  );
};

export default Localization;
